import { render } from "./AlterHeader.vue?vue&type=template&id=53ae3536"
const script = {}

import exportComponent from "/home/siluniv/projects/mediasphere/bluedot-play/origin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__